export default {
  init() {
    this.nav = null;
    this.huntMessage = null;
    this.huntLink = null;

    this._findElements();
    this._checkScrollPos();
    this._initHandler();
  },
  _initHandler() {
    $(document).on('scroll', this._checkScrollPos.bind(this));
  },
  _findElements() {
    this.nav = document.querySelector('.js-navbar');
    this.huntMessage = document.querySelector('.js-hunt-msg');
    this.huntLink = document.querySelector('.js-hunt-link');
  },
  _checkScrollPos() {
    const scrollPos = $(document).scrollTop();

    if (scrollPos >= 30) {
      this.nav.classList.add('scrolled');
    } else {
      this.nav.classList.remove('scrolled');
    }

    const MIN_SCROLL_POS_FOR_HUNT_BOX = 550;
    const isHuntBoxShowed = scrollPos >= MIN_SCROLL_POS_FOR_HUNT_BOX;

    if (isHuntBoxShowed) {
      this._showHuntBox();
    } else {
      this._hideHuntBox();
    }
  },
  _showHuntBox() {
    if (this.huntMessage) this.huntMessage.removeAttribute('style');
    if (this.huntLink) this.huntLink.removeAttribute('style');
  },
  _hideHuntBox() {
    if (this.huntMessage) this.huntMessage.setAttribute('style', 'display: none;');
    if (this.huntLink) this.huntLink.setAttribute('style', 'display: none;');
  },
};
